import { ActionType, ComponentType } from '../../enums';

export interface CreateCreditCardApplyEventPayloadOptions {
  itemName: string;
  itemType: string;
  paymentType: string;
  provider: string;
  url: string;
  savedCard: boolean;
  index: number;
  indexRange: number;
}

export interface CreateCreditCardApplyEventPayloadReturn {
  event_data: {
    action: ActionType.APPLY;
    component_type: ComponentType.ADYEN_PAYMENT_WIDGET;
    item_name: string;
    item_type: string;
    payment_type: string;
    provider: string;
    url: string;
    saved_card: boolean;
    index: number;
    index_range: number;
  };
}

export const createCreditCardApplyEventPayload = ({
  itemName,
  itemType,
  paymentType,
  provider,
  url,
  savedCard,
  index,
  indexRange,
}: CreateCreditCardApplyEventPayloadOptions): CreateCreditCardApplyEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.APPLY,
      component_type: ComponentType.ADYEN_PAYMENT_WIDGET,
      item_name: itemName,
      item_type: itemType,
      payment_type: paymentType,
      provider,
      url,
      saved_card: savedCard,
      index,
      index_range: indexRange,
    },
  };
};
